export function mountHow(root) {
  root.innerHTML = `
  <section class="how">
    <p class="eyebrow">How the water flows</p>
    <h1 class="display-md">One curve. One well. Forever.</h1>
    <div class="how-grid">
      <article class="panel how-card">
        <div class="how-num">I</div>
        <h3>Dig</h3>
        <p>A creator launches a token in a single transaction. All 1,000,000,000 tokens are minted onto a bonding curve,
        Metaplex metadata is written and the mint authority is revoked. The creator can make a dev buy in the same transaction.</p>
        <p class="muted">The dev buy goes straight to the creator's wallet. No lock, no vesting — it can be sold at any time.</p>
      </article>
      <article class="panel how-card">
        <div class="how-num">II</div>
        <h3>Trade</h3>
        <p>Price follows a constant-product curve on virtual reserves. Every buy and sell pays a fee.
        For the first 60 seconds after launch the fee starts at 15% and falls linearly to 4%, so snipers pay the well.</p>
        <p class="muted">There is no graduation and no migration: the token trades on its curve forever.</p>
      </article>
      <article class="panel how-card">
        <div class="how-num">III</div>
        <h3>Fill</h3>
        <p>1% of volume goes to the platform. Everything else from the fee — 3% normally, plus the whole anti-sniper surplus —
        falls into the token's well as SOL. Each trade is a drop; the well's level is the SOL inside that has not been claimed yet.</p>
      </article>
      <article class="panel how-card">
        <div class="how-num">IV</div>
        <h3>Drink</h3>
        <p>Holders lower tokens into the well (stake). New water collects in the well's reservoir and drains to the holders
        gradually, with roughly an hour time constant, shared pro-rata to their stake. Claim the water any time; unstake any time.</p>
        <p class="muted">The drip clock only runs while someone is in the well. If the well is empty, stored water waits;
        the first person to stake does not get it instantly, it starts draining from that moment.</p>        <p class="muted">Minimum stake is 1 whole token.</p>
      </article>
    </div>
    <div class="panel how-sim-link">
      <p><span class="demo-badge">Simulation</span>&nbsp; Want to see these rules move? The home page runs a labelled simulation of the fee decay, the well and the drain to holders.</p>
      <a class="btn btn-secondary" href="#/?sim">Watch the simulation</a>
    </div>
    <div class="panel how-risk">
      <h3>Know the risks</h3>
      <p>Memecoins are speculative and can go to zero. Creators can sell their dev buy at any time. Fees are charged on every trade.
      Smart contracts can have bugs. Never trade with money you cannot afford to lose.</p>
    </div>
    <p class="center"><a class="btn btn-primary" href="#/create">Dig a new well</a></p>
  </section>`;
  return () => {};
}
